module.exports = __webpack_public_path__ + "static/Implant bridge intraoral after-f5e48cb2cb5fe7e8ffbe1efa4145437e.jpg";